import { Box, Typography } from "@mui/material";

interface CustomFooterProps {
  totalValorTotal: number;
  totalValorMedido: number;
}

export const CustomFooterServicos = ({ totalValorTotal, totalValorMedido }: CustomFooterProps) => {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(value);
  };

  return (
    <Box sx={{ 
        p: 2, 
        display: 'flex', 
        justifyContent: 'flex-end', 
        alignItems: 'center',
        borderTop: '1px solid #e0e0e0',
        gap: 2 
    }}>
      <Typography variant="body2" fontWeight="bold">TOTAL:</Typography>
      <Box sx={{ textAlign: 'right', minWidth: 100 }}>
        <Typography variant="caption" display="block" color="text.secondary">Valor Total</Typography>
        <Typography variant="body2" fontWeight="bold">{formatCurrency(totalValorTotal)}</Typography>
      </Box>
      <Box sx={{ textAlign: 'right', minWidth: 100 }}>
        <Typography variant="caption" display="block" color="text.secondary">Valor Medido</Typography>
        <Typography variant="body2" fontWeight="bold">{formatCurrency(totalValorMedido)}</Typography>
      </Box>
    </Box>
  );
};